import {BoardContainer, TitleContainer,} from "../../assets/GlobalStyles";
import ReportsMedia from "./Media";
import ReportsInventory from "./ReportsInventory";
import ReportsPeriod from "./Period";
import ReportsAdExchange from "./AdExchange";
import {useParams} from "react-router-dom";
import ScrollToTop from "../../components/common/ScrollToTop";
import React from "react";
import ReportsHourPeriod from "./PeriodbyHour";
import styled from "styled-components";

export default function Reports(){
  const params = useParams()

  return(
    <ReportsPage>
      <ScrollToTop/>
      <BoardContainer>
        <TitleContainer>
          <div>
            <h1>보고서</h1>
          </div>
        </TitleContainer>
        {/* 일자별보고서 */}
        {params.id === 'reports' && <ReportsPeriod/>}
        {params.id === 'reportsHour' && <ReportsHourPeriod/>}
        {/* 매체별보고서 */}
        {params.id === 'reportsMedia' && <ReportsMedia/>}
        {/* 지면별보고서 */}
        {params.id === 'reportsInventory' && <ReportsInventory/>}
        {/* 외부연동수신보고서 */}
        {params.id === 'reportsAdExchange' && <ReportsAdExchange/>}
      </BoardContainer>
    </ReportsPage>
  )
};

const ReportsPage = styled.main`
  ${BoardContainer} {
    min-width: 0;
    margin: 0;
    border-radius: 0;
    background: transparent;
  }

  ${TitleContainer} h1 {
    margin: 0;
    color: rgb(32, 36, 43);
    font-size: var(--font-size-24);
    font-weight: 750;
    letter-spacing: -.025em;
  }
`;
